@if (suppliedGridQueryData) {
  <div class="modal-header">
    <h3 class="mb-0">Link vendor to {{ apSystemName }}</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    @if (Company && Vendor) {
      <dl class="link-summary">
        <div class="link-summary__row">
          <dt>Client</dt>
          <dd>
            {{ Company.legalName }}
            <span class="link-summary__id">ID {{ Company.id }}</span>
          </dd>
        </div>
        <div class="link-summary__row">
          <dt>VIVE legal name</dt>
          <dd>
            <a
              href="javascript:void(0)"
              class="link-summary__link"
              (click)="setFilterModel('legalName')"
            >
              {{ Vendor.legalName }}
            </a>
            <span class="link-summary__id">ID {{ Vendor.id }}</span>
          </dd>
        </div>
        @if (Vendor.dba) {
          <div class="link-summary__row">
            <dt>VIVE DBA</dt>
            <dd>
              <a
                href="javascript:void(0)"
                class="link-summary__link"
                (click)="setFilterModel('dba')"
              >
                {{ Vendor.dba }}
              </a>
            </dd>
          </div>
        }
        <div class="link-summary__row">
          <dt>VIVE tax ID</dt>
          <dd>
            <a
              href="javascript:void(0)"
              class="link-summary__link"
              (click)="setFilterModel(Vendor.ein ? 'ein' : 'ssn')"
            >
              {{ Vendor.ein ? Vendor.ein : '***-**-****' }}
            </a>
          </dd>
        </div>
        @if (StreetAddress) {
          <div class="link-summary__row">
            <dt>VIVE address</dt>
            <dd>
              <a
                href="javascript:void(0)"
                class="link-summary__link"
                (click)="setFilterModel('StreetAddress')"
              >
                {{ StreetAddress.address1 }}
                {{ StreetAddress.address2 || '' }}, {{ StreetAddress.city }},
                {{ StreetAddress.state }}
                {{ StreetAddress.zip }}
              </a>
            </dd>
          </div>
        }
        @if (MailingAddress) {
          <div class="link-summary__row">
            <dt>VIVE mailing address</dt>
            <dd>
              <a
                href="javascript:void(0)"
                class="link-summary__link"
                (click)="setFilterModel('MailingAddress')"
              >
                {{ MailingAddress.address1 }}
                {{ MailingAddress.address2 || '' }}, {{ MailingAddress.city }},
                {{ MailingAddress.state }}
                {{ MailingAddress.zip }}
              </a>
            </dd>
          </div>
        }
      </dl>

      @if (!hideWarningText) {
        <div class="link-warning">
          <i class="bi bi-info-circle link-warning__icon"></i>
          <span>
            Vendor updates must be made in your accounting system. VIVE syncs
            every 24 hours; refresh a specific vendor record using the
            operations below.
          </span>
        </div>
      }
    }

    <div class="link-grid">
      <app-ap-vendors-grid
        [gridName]="'ClientApVendorLinking'"
        [suppliedQueryData]="suppliedGridQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [getCalculatedColumnActions]="calculatedColumnActions"
        [FilterModel]="FilterModel"
        (actionEvent)="action($event)"
      >
      </app-ap-vendors-grid>
    </div>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-ghost" (click)="closeModal()">
        Close
      </button>
    </div>
  </div>
}
